import PrintButton from './printButton.component';
import './printButton.scss';

export default PrintButton;
